import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import AuthContent from './AuthContent'

const mapStateToProps = state => {
  const { AuthReducer } = state
  const { user = {}, error } = AuthReducer
  const { mobileNumber, id } = user
  return {
    mobileNumber,
    id,
    error,
  }
}

class ResetPasswordView extends React.Component {
  render() {
    return (
      <AuthContent
        title={translationService.passwordResetSuccessTitle()}
        subtitle={translationService.passwordResetSuccessIntro()}
        hasToken={false}>
        <Link to={routeService.getPrefixPath() + '/login'}>{translationService.passwordResetSuccessToLogin()}</Link>
      </AuthContent>
    )
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(ResetPasswordView)



// WEBPACK FOOTER //
// ./src/views/ResetPasswordSuccessView.js